export default {

  headerData: {
    headline: 'Welcome<br />to Particle.',
    background: {
      type: 'video',
      data: {
        src: '/static/content/uploads/contact-pdx-time-lapse.mp4',
        poster: '/static/content/uploads/contact-pdx-time-lapse.jpg',
        alt: 'picture of Particle\'s logo on the wall',
      },
    },
  },

  hiringData: {
    heading: {
      jobs: 'We&rsquo;re hiring.',
      noJobs: 'We&rsquo;re usually hiring.',
    },
    teaser: {
      jobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
      noJobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
    },
    listings: [
      // {
      //   jobTitle: 'Interaction Designer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622160016/',
      //   description: 'Make usuable, useful things',
      // },
      // {
      //   jobTitle: 'Sr. Front-End Developer',
      //   listingURL: 'https://www.linkedin.com/jobs/view/622112067/',
      //   description: 'Come play with us. Build prototypes for clients like Virgin Hyperloop One and Samsung and have a great time doing it.',
      // },
    ],
    noJobsContent: 'We don&rsquo;t have any specific needs, but we&rsquo;re always open to meeting new people. Feel free to introduce yourself.',
  },

  imageData: {
    reversed: false,
    image: {
      src: '/static/content/uploads/contact-collage.jpg',
      alt: 'office peep hard at work',
      height: 'medium',
      hAlign: 'left',
    },
  },

  mapData: {
    content: '## Hello.\n\nCome on down to our place. We have a keggerator, views of downtown Portland, and lots of whiteboard space for capturing your ideas.',
    image: {
      src: '/static/content/uploads/contact-office-location-light.png',
    },
  },
};



// WEBPACK FOOTER //
// ./src/content/contact-index.js